import { Outlet } from "react-router-dom"
import styled from "styled-components"

export const UnAuthAppLayout = () => {
    return (
        <StyledUnAuthAppLayout>
            <Outlet/>
        </StyledUnAuthAppLayout>
    )
}

const StyledUnAuthAppLayout = styled.div`
    background: ${({theme}) => theme.colors.neutralSecondaryBackground};
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};
    justify-content: center;
    align-items: center;
`